// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nG5E","left":"styles_left__1oq-3"};